import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import JsBarcode from "jsbarcode";
import jsPDF from "jspdf";

function Barcodesheetmodal() {
  const barcodeRefs = useRef([]);
  const [selectedId, setSelectedId] = useState([]);
  const [value, setValue] = useState([0]);
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = `${index}`;
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0"); // Zerofill at the barcode

      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  useEffect(() => {
    let barcodeRequestParam = localStorage
      .getItem("BarcodeRequestParam");

      if(barcodeRequestParam!= "" && barcodeRequestParam != null)
      {
        barcodeRequestParam= barcodeRequestParam.split(",");
        setSelectedId(barcodeRequestParam.map((val) => parseInt(val, 10)));
      }
      
    

    setTimeout(function () {
      generateBarcodes(selectedId);
    }, 2000);
  }, [localStorage.getItem("BarcodeRequestParam")]);

  const refreshpage = () => {
    window.location.reload();
  };

  const downloadPdf = () => {
    generateBarcodes(selectedId);
    const pdf = new jsPDF();
    barcodeRefs.current.forEach((barcodeRef) => {
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");

      // pdf.addImage(imgData, "PNG", 10, 10);
      pdf.addImage(imgData, "PNG", 10, value * data.height);
      pdf.addPage();
      pdf.deletePage(selectedId.length + 1);
    });
    pdf.save("barcodes.pdf");

    window.location.reload(true);
  };

  return (
    <>
      <div
        className="modal fade"
        id="BarcodeSheetModal"
        tabIndex={-1}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Number Of Labels to Skip</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <input
                    type="number"
                    className="form-control "
                    placeholder="No of labels to skip "
                    onChange={(event) => setValue(event.target.value)}
                  ></input>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                to="#"
                className="btn btn-primary btn-md me-1 form-control text-align-center"
                data-bs-dismiss="modal"
                onClick={() => downloadPdf()}
              >
                Submit{" "}
              </Link>
            </div>

            <div id="barcode-output">
              {selectedId.map((item) => (
                <div key={item}>
                  <canvas
                    data-name={item}
                    ref={(el) => (barcodeRefs.current[item] = el)}
                    id={`barcode-${item}`}
                    className="d-none"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Barcodesheetmodal;
